<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"EMPLOYEE.EXPERIENCE.EXPERIENCE"|translate}}</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <form action="" class="o-h" [formGroup]="addForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-md-6 mt-3 mt-3 mt-lg-4">
                    <label for="">{{"EMPLOYEE.EXPERIENCE.EXPERIENCE"|translate}}
                        {{"EMPLOYEE.EXPERIENCE.SECTOR"|translate}}</label>
                    <div class="form-input">
                        <input type="text" class="form-control"
                            placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.EXPERIENCE.SECTOR' | translate}}"
                            formControlName="e_s">
                    </div>
                    <mat-error *ngIf="isControlHasError('e_s','required')"> {{"This is required"|translate}}</mat-error>
                </div>
                <div class="col-md-6 mt-3 mt-lg-4">
                    <label for="">{{"EMPLOYEE.EXPERIENCE.POSITION"|translate}}</label>
                    <div class="form-input">
                        <input type="text" class="form-control"
                            placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.EXPERIENCE.POSITION'|translate}}"
                            formControlName="pos">
                    </div>
                    <mat-error *ngIf="isControlHasError('pos','required')"> {{"This is required"|translate}}</mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6  mt-3 mt-lg-4">
                    <label for="">{{"COMMON.STARTDATE"|translate}}</label>
                    <div class="in-box">
                        <input class="form-control in-i" [matDatepicker]="startDate" formControlName="st_dt"/>
                        <mat-datepicker-toggle matIconSuffix [for]="startDate"  class="mat-date"></mat-datepicker-toggle>
                        <mat-datepicker #startDate ></mat-datepicker>
                    </div>
                    <div>
                        <mat-error *ngIf="isControlHasError('st_dt','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
                <div class="col-md-6 mt-3 mt-lg-4">
                    <label for="">{{"COMMON.ENDDATE"|translate}}</label>
                    <div class="in-box">
                        <input class="form-control in-i" [matDatepicker]="endDate" formControlName="ed_dt"/>
                        <mat-datepicker-toggle matIconSuffix [for]="endDate"  class="mat-date"></mat-datepicker-toggle>
                        <mat-datepicker #endDate ></mat-datepicker>
                    </div>
                    <div>
                     <mat-error *ngIf="isControlHasError('ed_dt','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3 ">
                    <mat-checkbox [color]="'primary'" formControlName="ref">{{"EMPLOYEE.EXPERIENCE.REFERENCE"|translate}} </mat-checkbox>
                    <div>
                        <mat-error *ngIf="isControlHasError('ref','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="addForm.value.ref==true">
                <div class="col-12 mt-3 ">
                    <label for="">{{"EMPLOYEE.EXPERIENCE.NAMEREFERENCE"|translate}}</label>
                    <div class="form-input">
                        <input type="text" class="form-control"
                            placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NAME' | translate}}"
                            formControlName="n_or">
                    </div>
                    <mat-error *ngIf="isControlHasError('n_or','required')"> {{"This is required"|translate}}</mat-error>
                </div>
            </div>
            <div class="row" *ngIf="addForm.value.ref==true">
                <div class="col-12 mt-3 mt-lg-4">
                    <label for="">{{"EMPLOYEE.EXPERIENCE.NUMBER"|translate}}</label>
                    <div class="form-input">
                        <input type="text" class="form-control"
                            placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.EXPERIENCE.REFERENCE' | translate}}"
                            formControlName="co_re">
                    </div>
                    <mat-error *ngIf="isControlHasError('co_re','required')"> {{"This is required"|translate}}</mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3 mt-lg-4">
                    <label for="">{{"EMPLOYEE.EXPERIENCE.ISCURRENTEMPLOYER"|translate}}?</label>
                    <mat-radio-group class="d-flex rd-box" formControlName="c_emp">
                        <div class="d-flex">
                            <mat-radio-button class="" value="yes"></mat-radio-button>
                            <div class="radio-title l-h">{{"COMMON.YES"|translate}}</div>
                        </div>
                        <div class="d-flex ms-4 rd-l">
                            <mat-radio-button class="" value="no"></mat-radio-button>
                            <div class="radio-title  l-h">{{"COMMON.NO"|translate}}</div>
                        </div>
                    </mat-radio-group>
                    <div>
                        <mat-error *ngIf="isControlHasError('c_emp','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                (click)="onSubmit()">{{ "Save" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>